<template>
  <div class="list-sort-box list-box">
    <div class="sort-item-list company">
      <div  @click="change_filter('?',$event)"  class="sort-item active">
        <img src="https://www.wishket.com/static/img/project/icon_sorting_check.png">기본 정렬 순
      </div>
      <div  @click="change_filter('-star_point',$event)"  class="sort-item">
        <img src="https://www.wishket.com/static/img/project/icon_sorting_check.png">평점 높은 순
      </div>
      <div  @click="change_filter('-view_count',$event)"  class="sort-item">
        <img src="https://www.wishket.com/static/img/project/icon_sorting_check.png">조회수 순
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  
  methods:{
    change_filter(str,e){
      $(".company>.sort-item").removeClass("active")
      $(e.target).addClass("active")
      EventBus.$emit("change_filter", str)
    }
  }
  
};
</script>

<style scoped lang="scss">
.list-sort-box {
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: 0 1px 0 0 #dedede;
  border: 1px solid #dedede;
  margin-bottom: 6px;
  height: 39px;
  line-height: 13px;
  padding: 13px 16px;
  .sort-item {
    display: inline-block;
    margin-left: 12px;
    padding-left: 12px;
    font-size: 13px;
    color: #333333;
    border-left: 1px solid #dedede;
    cursor: pointer;
  }
  .sort-item-list .sort-item:first-of-type {
    border: none;
    margin: 0;
    padding: 0;
  }
  .sort-item.active img {
    display: initial;
  }
  .sort-item img {
    display: none;
    width: 13px;
    height: 13px;
    margin-right: 5px;
  }
  .sort-item.active {
    font-weight: bold;
  }
  .sort-item {
    display: inline-block;
    margin-left: 12px;
    padding-left: 12px;
    font-size: 13px;
    color: #333333;
    border-left: 1px solid #dedede;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/SPA/CompanyList/Components/CompanyListSort.vue